export function showSnackbar(name, config = {}) {
  return {
    type: 'SHOW_SNACKBAR',
    name,
    config
  };
}

export function hideSnackbar(name) {
  return {
    type: 'HIDE_SNACKBAR',
    name
  };
}
